import { Box, Button, Stack, Typography } from "@mui/material";
import React, { ReactElement, useCallback, useMemo } from "react";
import { ReportType } from "../../abstract/Report";
import InfoRow from "../../components/InfoRow";
import { useApp } from "../../contexts/AppContext";
import { colors } from "../../theme";
import { getAge } from "../../utils";
import { GetCycleResponseItem } from "./types";

const PatientInfoCard: React.FC<{
  cycle: GetCycleResponseItem;
  onExpand: () => void;
  type?: ReportType;
}> = ({ cycle, onExpand, type }) => {
  const patient = {
    ...cycle,
    name: cycle.patient,
    birth: new Date(cycle.birth),
    created: new Date(cycle.created),
  };

  const patientInfoRow = useCallback(
    (label: string, value: string | number | ReactElement, date?: Date) => (
      <InfoRow labelWidth={150} label={label} value={value} date={date} />
    ),
    []
  );

  const { translate } = useApp();
  const translations = useMemo(() => translate("oocyte"), [translate]);
  const geenralTranslations = useMemo(() => translate("general"), [translate]);

  return (
    <Stack
      sx={
        type === "report"
          ? { backgroundColor: colors.stone[50], borderRadius: 4, padding: 2 }
          : {}
      }
      direction="row"
      justifyContent="space-between"
      alignItems={"flex-start"}
    >
      <Stack spacing={2} maxWidth={300}>
        {patientInfoRow(translations.patientInfo.name, patient.name)}
        {patientInfoRow(translations.patientInfo.age, getAge(patient.birth))}
        {patientInfoRow(translations.patientInfo.height, patient.height)}
      </Stack>
      <Stack spacing={2} maxWidth={300}>
        {patientInfoRow(translations.patientInfo.weight, patient.weight)}
        {patientInfoRow(
          translations.patientInfo.retrievalDate,
          patient.retrieval_date ? new Date(patient.retrieval_date).toLocaleDateString() : ''
        )}
        {patientInfoRow(
          translations.patientInfo.numberOfOocytes,
          patient.retrieval_value ?? patient.images.length
        )}
      </Stack>

      {type !== "report" && (
        <Box>
          <Button onClick={onExpand} variant="text">
            <Typography fontSize={14} sx={{ textDecoration: "underline" }}>
              {geenralTranslations.patientInfo.seeMore}
            </Typography>
          </Button>
        </Box>
      )}
    </Stack>
  );
};

export default PatientInfoCard;
